import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { fontFamilySans } from "@clockwise/web-commons/src/styles/type.styles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const configurationPane: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  width: 500,
  padding: "50px 40px 100px",
  overflow: "auto",

  "&::-webkit-scrollbar": {
    width: "4px",
    "&:hover ::-webkit-scrollbar-thumb": {
      background: "rgba(0, 0, 0, 0.2)",
    },
  },
};

export const displayPane: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  flex: 1,
  background: greys.palePaleGrey,
  padding: "35px 77px 77px",

  "& > .relative-view-wrapper": {
    width: "100%",
    height: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",

    "& > .day-name": {
      height: 30,
      textAlign: "center",
      fontFamily: fontFamilySans,
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "12.8672px",
      lineHeight: "15px",
      color: "#96ACC0",
    },

    "& > .relative-view": {
      borderRight: "1px solid #ccc",
      background: "#fff",
      flex: 1,
    },

    "&:last-child": {
      borderRight: "none",
    },
  },
};

export const stepPill: CSSProperties = {
  userSelect: "none",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  marginBottom: 35,

  "& > .pill-container": {
    borderRadius: "20px",
    border: "1px solid rgba(34, 85, 136, 0.1)",
    padding: 4,

    "& > .pill": {
      display: "inline-block",
      cursor: "pointer",
      fontFamily: fontFamilySans,
      fontSize: "15px",
      lineHeight: "35px",
      borderRadius: "20px",
      color: "#225588",
      padding: "0 13px",

      "&.active": {
        cursor: "unset",
        background: "#225588",
        color: "#fff",
      },

      "&.disabled": {
        cursor: "not-allowed",
        color: greys.cloudyBlue,
      },
    },
  },
};

export const styles = {
  configurationPane,
  displayPane,
  stepPill,
};
